export const NFC_PAIRING_COMMAND = Uint8Array.from([
  0x00, // CLA
  0xa4, // INS
  0x04, // P1
  0x00, // P2
  0x07, // LC
  // DATA
  0xf0,
  0x02,
  0x4c,
  0x77,
  0x4d,
  0x32,
  0x4d,
  // --
  0x90, // SW1
  0x00, // SW2
]);

export const DEFAULT_TAP_MAX_FRAME_SIZE = 256 - 6; // Lc = u8 legnth - 5 header bytes  - 1 byte "Le"
